import { Center, Stack, Loader, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import styles from './LazyComponentFallback.module.css';
import { LazyComponentFallbackProps } from './LazyComponentFallback.types';

export const LazyComponentFallback = ({
  componentName,
  size = 'md',
}: LazyComponentFallbackProps) => {
  const { t } = useTranslation();

  return (
    <Center className={styles.container}>
      <Stack align="center" gap="md">
        <Loader size={size} />
        {componentName && (
          <Text size="sm" c="dimmed">
            {t('common.loadingComponent', { component: componentName })}
          </Text>
        )}
      </Stack>
    </Center>
  );
};

export const MapFallback = () => (
  <LazyComponentFallback componentName="Map" size="lg" />
);
